import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CollapsibleService {
  public boxExpanded: Subject<null>;

  constructor() {
    this.boxExpanded = new Subject();
  }

  public collapseBoxes() {
    this.boxExpanded.next(null);
  }
}
